export default function IconAddUser() {
  return (
    <svg
      fill="none"
      height="30"
      viewBox="0 0 24 24"
      width="30"
      xmlns="http://www.w3.org/2000/svg"      
    >
      <path
        clipRule="evenodd"
        d="m17 6c0 2.76142-2.2386 5-5 5-2.76142 0-5-2.23858-5-5s2.23858-5 5-5c2.7614 0 5 2.23858 5 5zm-7 7c-3.86599 0-7 3.134-7 7 0 1.6569 1.34315 3 3 3h7.4093c.4322 0 .6777-.5279.4539-.8977-.5479-.9052-.8632-1.9669-.8632-3.1023 0-2.0341 1.0122-3.8318 2.5604-4.9169.3634-.2546.3324-.8389-.1017-.9309-.4705-.0997-.9585-.1522-1.4587-.1522zm9 2c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5522-.4477 1-1 1s-1-.4478-1-1v-2h-2c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1z"
        fill="#"
        fillRule="evenodd"
      ></path>
    </svg>
  );
}
